var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 7.5L6.5 1.5M6.5 1.5L11.9142 6.91421C12.2032 7.20324 12.3478 7.34776 12.5315 7.42388C12.7153 7.5 12.9197 7.5 13.3284 7.5H21.5L17.6994 2.93926C17.1096 2.23152 16.8147 1.87764 16.4116 1.68882C16.0084 1.5 15.5478 1.5 14.6265 1.5H6.5Z",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5808",
    d: "M10.5 5.5V17.5H2.5V6.35714",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5809",
    d: "M10.5 17.5H20.5V6.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5810",
    d: "M3.5 5V1.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.50801 9.5L6.49902 9.5",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5811",
    d: "M6.5 17.5V13.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5812",
    d: "M14.5 11.5L16.5 11.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon9);
export default __webpack_public_path__ + "static/media/LineIcon9.c4f93b8f7ef35d27edb6ced19777fea7.svg";
export { ForwardRef as ReactComponent };